import OfficeEditorMarginsModal from './OfficeEditorMarginsModal';

export default OfficeEditorMarginsModal;
